<template>
  <ApplicationLayout
    :user="user"
    :options="options"
    :version="version"
    :links="links"
    :showActionItems="false"
  >
    <!-- Set System bar content if enabled-->
    <template #systembar> </template>

    <!-- Set Appbar title-->
    <template #title>
      <v-toolbar-title class="font-weight-bold d-flex">
        <span>Settings</span>
      </v-toolbar-title>
      <v-icon small style="margin-top: -20px">mdi-cog-outline</v-icon>
    </template>

    <!-- Use to add addition items to Appbar -->
    <template #toolbar>
      <ReportIssueButton />
      <FollowUpActionsMenu />
      <v-btn class="mr-2" icon to="/app/">
        <v-icon>mdi-home-outline</v-icon>
      </v-btn>
    </template>

    <!-- Use change Navbar header content-->
    <template #navheader> </template>

    <!-- Use display content-->
    <template #content>
      <v-sheet :color="'#fafbfc'" class="fill-height">
        <v-container class="py-8 px-md-1">
          <router-view />
        </v-container>
      </v-sheet>
    </template>
  </ApplicationLayout>
</template>

<script>
import ApplicationLayout from '@/modules/shared/components/core/layouts/ApplicationLayout.vue';
import ReportIssueButton from '@/modules/shared/components/core/ReportIssueButton.vue';
import FollowUpActionsMenu from '@/modules/shared/components/follow-up-actions/FollowUpActionsMenu.vue';
import CoreMixin from '@/mixins/core.mixin';
import FeatureMixin from '@/mixins/feature.mixin';
import settingsNav from '@/router/data/settingsNav.json';

const layoutOptions = {
  showSystemBar: false,
  showSearchBar: false,
  showUserOptions: true,
  showMenuToggle: true,

  appBarColor: '#fafbfc',
  miniDrawerColor: '',
  miniDrawerIconsColor: 'white',
  leftDrawerColor: 'white',
  leftDrawerIconsColor: ''
};

export default {
  components: {
    ApplicationLayout,
    ReportIssueButton,
    FollowUpActionsMenu
  },
  mixins: [CoreMixin, FeatureMixin],
  data: () => ({
    options: layoutOptions,
    rawLinks: settingsNav
  }),
  computed: {
    links() {
      const filterNavItems = (items) => {
        return items.filter((item) => {
          if (item.featureKey && !this.hasFeature(item.featureKey)) {
            return false;
          }
          if (item.items) {
            item.items = filterNavItems(item.items);
          }
          return true;
        });
      };
      return filterNavItems(this.rawLinks);
    }
  }
};
</script>
